import { useState } from 'react';
import { useProductInfoStore, useDigitalDataStore } from '../store';

export const useCallout = ({ omsId, itemId, analyticsConfig = null }) => {
  const productInfo = useProductInfoStore((state) => state.productInfo);
  const trackCalloutModalLinkClickEvent = useDigitalDataStore((state) => state.trackCalloutModalLinkClickEvent);
  const trackCalloutModalCloseEvent = useDigitalDataStore((state) => state.trackCalloutModalCloseEvent);
  const displayCallout = omsId === itemId && Boolean(productInfo?.portableStorageCallout);
  const [isDecisionModalOpen, setDecisionModalOpen] = useState(false);

  const handleCalloutClick = () => {
    if (analyticsConfig) {
      trackCalloutModalLinkClickEvent(analyticsConfig.open.feature, {
        name: analyticsConfig.open.name,
        type: `${productInfo?.brand} ${productInfo.displayName}`,
        eventName: analyticsConfig.open.eventName
      });
    }
    setDecisionModalOpen(true);
  };

  const handleDecisionModalClose = () => {
    if (analyticsConfig) {
      trackCalloutModalCloseEvent(analyticsConfig.close.feature, {
        name: analyticsConfig.close.name,
        type: `${productInfo?.brand} ${productInfo.displayName}`,
        eventName: analyticsConfig.close.eventName
      });
    }
    setDecisionModalOpen(false);
  };

  return {
    displayCallout,
    isDecisionModalOpen,
    handleCalloutClick,
    handleDecisionModalClose
  };
};
